<div class="w-[1200px]">
  <h2 class="font-semibold mb-4">Загрузка инвойсов</h2>
  <div class="my-2">
    <app-files-input
      [accept]="
        [
          mimeTypes.APPLICATION_PDF,
          mimeTypes.EXCEL,
          mimeTypes.EXCEL_OLD,
          mimeTypes.APPLICATION_ZIP
        ].join()
      "
      [formControl]="files"
    ></app-files-input>
  </div>
  <div class="flex gap-x-2 justify-end">
    <button tuiButton appearance="outline" size="m" (click)="close()">
      Отмена
    </button>
    <button
      [disabled]="files.invalid"
      tuiButton
      size="m"
      (click)="upload$.next()"
    >
      Загрузить
    </button>
  </div>
</div>
